module.exports = __webpack_public_path__ + "media/images/google-drive-color-bf9887b7aa8dce22b4538737c2d22103.svg";